var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventNote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 31,
    viewBox: "0 0 28 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 3.28418H24.5C26.15 3.28418 27.5 4.63418 27.5 6.28418V27.2842C27.5 28.9342 26.15 30.2842 24.5 30.2842H3.5C1.835 30.2842 0.5 28.9342 0.5 27.2842V6.28418C0.5 4.63418 1.835 3.28418 3.5 3.28418H5V1.78418C5 0.95918 5.675 0.28418 6.5 0.28418C7.325 0.28418 8 0.95918 8 1.78418V3.28418H20V1.78418C20 0.95918 20.675 0.28418 21.5 0.28418C22.325 0.28418 23 0.95918 23 1.78418V3.28418ZM8 13.7842H20C20.825 13.7842 21.5 14.4592 21.5 15.2842C21.5 16.1092 20.825 16.7842 20 16.7842H8C7.175 16.7842 6.5 16.1092 6.5 15.2842C6.5 14.4592 7.175 13.7842 8 13.7842ZM23 27.2842H5C4.175 27.2842 3.5 26.6092 3.5 25.7842V10.7842H24.5V25.7842C24.5 26.6092 23.825 27.2842 23 27.2842ZM8 19.7842H15.5C16.325 19.7842 17 20.4592 17 21.2842C17 22.1092 16.325 22.7842 15.5 22.7842H8C7.175 22.7842 6.5 22.1092 6.5 21.2842C6.5 20.4592 7.175 19.7842 8 19.7842Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventNote);
export default __webpack_public_path__ + "static/media/event-note.b6e1a526.svg";
export { ForwardRef as ReactComponent };